export enum BASE_VARIANT {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger',
}

export enum BASE_SIZE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export const BASE_SPACING = {
  ...BASE_SIZE,
} as const;

export const BASE_RADIUS = {
  ...BASE_SIZE,
  NONE: 'none',
  FULL: 'full',
} as const;

export const BASE_SHADOW = {
  ...BASE_SIZE,
  INSET: 'inset',
} as const;

export enum BASE_ORIENTATION {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
